
import {Component, Vue} from "vue-property-decorator";
import {SenkronPlan, SenkronPlanYazmaCevabi} from "@/services/senkronPlanService";
import {saatiEkranBicimine} from "@/services/senkronPlanGovde";

/** Plan listesi (Faz 3, DEV-2966). Pasif planlar da listelenir — anahtar burada. */
@Component
export default class SenkronPlanListesi extends Vue {
  islenenId: number | null = null;
  silmeOnayi = false;
  siliniyor = false;
  silinecek: SenkronPlan | null = null;
  /**
   * kod inceleme: T2-01 — plan.id → başarısız aktifDegistir denemesi sayacı.
   * Aşağıdaki template'teki v-switch key'i buna bağlı, plan.aktif'e DEĞİL:
   * PATCH reddedilince plan.aktif tazeleme sonrası da AYNI kalabilir, o yüzden
   * key'i ona bağlamak yeterli değildi (bkz. aktifDegistir'in catch bloğu).
   */
  hataSayaclari: Record<number, number> = {};

  get planlar(): Array<SenkronPlan> {
    return this.$store.getters["senkronPlan/planlar"];
  }

  get aktifSayisi(): number {
    return this.$store.getters["senkronPlan/aktifPlanSayisi"];
  }

  get yukleniyor(): boolean {
    return this.$store.getters["senkronPlan/planYukleniyor"];
  }

  get denendiMi(): boolean {
    return this.$store.getters["senkronPlan/planDenendiMi"];
  }

  get hata(): string | null {
    return this.$store.getters["senkronPlan/planHatasi"];
  }

  saat(deger: string): string {
    return saatiEkranBicimine(deger);
  }

  dosyaSayisi(plan: SenkronPlan): number {
    return plan.dosya_secimi.dosyalar.length;
  }

  yenile() {
    this.$store.dispatch("senkronPlan/planlariYukle");
  }

  /**
   * Yalnız `aktif` alanını PATCH'ler.
   *
   * Aktiflik değişimi sunucuda "üretimi etkileyen değişiklik"tir: pasifleştirme
   * o gecenin paketini iptal eder, yeniden aktifleştirme yeniden üretebilir. Bu
   * yüzden dönen `mesaj` kullanıcıya gösterilir — sessizce yutulursa kullanıcı
   * "kapattım ama görevler duruyor" (ya da tersi) ile karşılaşır. Gösterim burada
   * toast İLE değil, `degisti` olayını dinleyen SenkronPlanView'daki kalıcı şerit
   * ile yapılır: kod inceleme — ikisi birden aynı cümleyi iki kez gösteriyordu.
   */
  async aktifDegistir(plan: SenkronPlan, deger: any) {
    const aktif = deger === true || deger === "true";
    if (aktif === plan.aktif) return;

    this.islenenId = plan.id;
    try {
      const cevap: SenkronPlanYazmaCevabi = await this.$store.dispatch(
          "senkronPlan/planAktifDegistir",
          {id: plan.id, aktif}
      );
      this.$emit("degisti", cevap);
    } catch (e: any) {
      console.error("Plan aktifliği değiştirilemedi:", e);
      this.$toast.error("Planın aktifliği değiştirilemedi.");
      // kod inceleme: T2-01 — switch'in optimistik lazyValue'sunu (Vuetify, tıklamayla
      // yerelde zaten ters çevrilmiş) sıfırlatmak için key'i KESİN değiştiriyoruz;
      // plan.aktif'e bağlı bir key bunun için yeterli değildi çünkü aşağıdaki tazeleme
      // plan.aktif'i DEĞİŞTİRMEDEN dönebilir (asıl bulgunun senaryosu).
      this.$set(this.hataSayaclari, plan.id, (this.hataSayaclari[plan.id] || 0) + 1);
      // Sunucu reddettiyse anahtar gerçeği göstersin: liste tazelenir.
      // kod inceleme: await edilir — tazeleme bitmeden `finally` islenenId'yi
      // sıfırlayıp switch'i tekrar tıklanabilir yapmasın; yukarıdaki key değişikliği de
      // en son çıkan (gerçek) plan.aktif'ten kurulacaksa önce store'un güncellenmesi gerekir.
      await this.$store.dispatch("senkronPlan/planlariYukle");
    } finally {
      this.islenenId = null;
    }
  }

  silmeyiSor(plan: SenkronPlan) {
    this.silinecek = plan;
    this.silmeOnayi = true;
  }

  async sil() {
    if (!this.silinecek) return;
    this.siliniyor = true;
    try {
      await this.$store.dispatch("senkronPlan/planSil", this.silinecek.id);
      this.$toast.success("Plan silindi.");
      this.silmeOnayi = false;
      this.silinecek = null;
    } catch (e: any) {
      console.error("Plan silinemedi:", e);
      this.$toast.error("Plan silinemedi.");
    } finally {
      this.siliniyor = false;
    }
  }
}
